var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSiemensMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.616,
    height: 19.511,
    viewBox: "0 0 14.616 19.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M15.09,3.328V6.981a14.542,14.542,0,0,0-5.048-1.076A4.039,4.039,0,0,0,7.95,6.38a1.369,1.369,0,0,0-.79,1.162c0,.609.6,1.151,1.787,1.636l3.434,1.671c2.765,1.324,4.145,3.081,4.145,5.288a5.178,5.178,0,0,1-2.2,4.383,9.651,9.651,0,0,1-5.894,1.636A27.4,27.4,0,0,1,5.382,22a23.807,23.807,0,0,1-3.089-.582V17.6a18.237,18.237,0,0,0,5.76,1.075c2.065,0,3.092-.6,3.092-1.806,0-.6-.418-1.086-1.264-1.466L6.066,13.778a7.7,7.7,0,0,1-3.137-2.321A5.183,5.183,0,0,1,1.91,8.272,4.828,4.828,0,0,1,4.031,4.185,9.361,9.361,0,0,1,9.662,2.644a21.118,21.118,0,0,1,2.614.191C13.247,2.967,14.187,3.129,15.09,3.328Z",
    transform: "translate(-1.91 -2.644)",
    fill: "#099",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSiemensMobile);
export default __webpack_public_path__ + "static/media/logo-siemens-mobile.14b30b6276d40b6ef9dcfb49b987964d.svg";
export { ForwardRef as ReactComponent };